import { styled } from '@mui/material';

export const PoliciesSectionWrap = styled('div')(() => ({
	display: 'grid',
	gap: '24px',
	gridTemplateColumns: '1fr',
}));
